import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Flex,
  Input,
  notification,
  PaginationProps,
  Table,
  TableColumnsType,
  Tabs,
} from "antd";
import {
  Calendar2,
  DocumentDownload,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import { Link } from "react-router-dom";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
} from "@ant-design/icons";
import { mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
import { RangePickerProps } from "antd/es/date-picker";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current > dayjs().endOf("day");
};

// import { IMAGE_URL2 } from '../../env'

// const fallbackAvatar = 'data:image/png;base64,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'

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const ListPayment: React.FC = () => {
  // TABS
  const [currentTab, setCurrentTab] = useState("1");
  const tabs = [
    { key: "1", label: "Paid" },
    { key: "0", label: "Unpaid" },
  ];
  const onTabChange = (e: string) => {
    setCurrentTab(e);
    setParams({
      ...params,
      type: "",
      owner_id: "",
      name_or_phone: "",
      status_pay: Number(e),
    });
    setSearchQuery("");
  };
  // END TABS

  // TABLE
  const columns: TableColumnsType = [
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "Store ID",
      dataIndex: "storeId",
      key: "storeId",
    },
    {
      title: "Store name",
      dataIndex: "storeName",
      key: "storeName",
    },
    {
      title: "Seller name",
      dataIndex: "seller_name",
      key: "seller_name",
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: () =>
        currentTab === "1" ? (
          <Badge status="success" text="Paid" className="rs-badge background" />
        ) : (
          <Badge status="error" text="Unpaid" className="rs-badge background" />
        ),
    },
    ...(currentTab === "1"
      ? [
          {
            title: "Refund",
            dataIndex: "is_refund",
            key: "is_refund",
            align: "center" as const,
            render: (value: any, record: any) => (
              <Checkbox
                checked={value === 1}
                disabled={tableLoading}
                onChange={(e) =>
                  handleRefundChange(record.pay_id, e.target.checked)
                }
              />
            ),
          },
        ]
      : []),
    {
      title: "Amount ($)",
      dataIndex: "amount",
      key: "amount",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: currentTab === "1" ? "Paid at" : "",
      dataIndex: "paidDate",
      key: "paidDate",
      // width: 422,
      render: (value) => (currentTab === "1" ? <span>{value}</span> : ""),
    },
    {
      title: currentTab === "1" ? "Payment method" : "",
      dataIndex: "pay_method_name",
      key: "pay_method_name",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type, record) => (
        // <Badge status={storeType(type).color} text={ record.type_name } className='rs-badge background' />
        <Badge
          status={type === "Full services" ? "warning" : "default"}
          text={type}
          className="rs-badge background"
        />
      ),
    },
    {
      title: "Phone number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Owner name",
      dataIndex: "owner_name",
      key: "owner_name",
      render: (value, record) => (
        <Flex align="center" gap={12}>
          {/* <Avatar src="/images/avatar.png" size={40} /> */}
          {/* <Image
            height={40}
            width={40}
            src={`${IMAGE_URL2}${record.avatar}`}
            alt={record.customerName}
            preview={{
              src: `${IMAGE_URL2}${record.avatar}`
            }}
            style={{ borderRadius: '50%', overflow: 'hidden' }}
            fallback={fallbackAvatar}
          /> */}
          <span>{value}</span>
        </Flex>
      ),
    },
  ];
  // END TABLE

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [totalIncome, setTotalIncome] = useState(0);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    type?: any;
    owner_id?: any;
    name_or_phone?: string;
    status_pay?: number;
    fromDate?: string;
    toDate?: string;
  }>({
    limit: 10,
    page_number: 1,
    status_pay: Number(currentTab),
  });

  const getItems = async () => {
    setTableLoading(true);
    const res = await mixPostV1("/api/webAdmin/gListPayment.php", params);

    if (res.status === 1) {
      setTotalIncome(res?.income);
      const result: any = [];
      res.data.map((item: any, index: number) =>
        result.push({
          ...item,
          key: index,
          storeId: item.store_id,
          storeName: item.store_name,
          status: item.status_pay,
          paidDate: item.create_at,
          type: item.type_name,
          ownerName: item.owner_name,
          amount: item.income,
          seller_name: item?.seller_name,
          // avatar: item.avatar,
        }),
      );
      setItems({
        ...items,
        list: result,
        total: res.totalRecord,
      });
      setTableLoading(false);
    }
  };

  const handleRefundChange = async (pay_id: string, checked: boolean) => {
    try {
      const newRefundValue = checked ? 1 : 0;
      const payload = {
        pay_id: pay_id,
        is_refund: newRefundValue,
      };

      setTableLoading(true);
      const res = await mixPostV1(
        "/api/webAdmin/updateRefundStatus.php",
        payload,
      );

      if (res.status === 1 || res.status === "success") {
        openNotification("success", "Updated refund status successfully!");
        getItems();
      } else {
        openNotification(
          "error",
          res.message || "Failed to update refund status!",
        );
        setTableLoading(false);
      }
    } catch (error) {
      openNotification(
        "error",
        "An error occurred while updating refund status.",
      );
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const onSearch = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      name_or_phone: query,
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    setSearchQuery(e.target.value);
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };
  // END SEARCH

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gListPayment.php",
        customParams,
      );

      if (res.status) {
        if (res.data.length > 0) {
          currentTab === "1"
            ? formattedDataExcelPaid(res.data)
            : formattedDataExcelUnpaid(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcelPaid = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "Store ID": item.store_id,
        "Store Name": item.store_name,
        Status: "Paid",
        "Paid at": item.create_at,
        "Phone number": item.phone_number,
        "Owner name": item.owner_name,
        Amount: item.income,
      };
    });
    exportExcel(formattedData);
  };
  const formattedDataExcelUnpaid = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "Store ID": item.store_id,
        "Store Name": item.store_name,
        Status: "Unpaid",
        "Phone number": item.phone_number,
        "Owner name": item.owner_name,
        Amount: item.income,
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(
        excelBuffer,
        `${
          currentTab === "1" ? "List payment (paid)" : "List payment (unpaid)"
        }.xlsx`,
      );
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };
  const onRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[],
  ) => {
    if (dates) {
      setParams({
        ...params,
        page_number: 1,
        fromDate: dateStrings[0],
        toDate: dateStrings[1],
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        fromDate: "",
        toDate: "",
      });
    }
  };
  return (
    <>
      {contextHolder}

      <Layout contentClassName="sales-report-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "List payment" },
          ]}
          title="List payment"
          description=""
        />

        <Tabs
          activeKey={currentTab}
          items={tabs}
          className="rs-tabs"
          onChange={onTabChange}
        />

        <div className="table-filter-block rps-600-flex-column">
          <Input
            value={searchQuery}
            placeholder="Search by owner name or phone number"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            allowClear
            className="rs-input table-filter-block__search"
            onPressEnter={(e) => onEnter(e)}
            onChange={(e) => onChange(e)}
          />
          <RangePicker
            allowClear
            className="rs-range-picker"
            suffixIcon={<Calendar2 size={20} />}
            separator={<LineOutlined />}
            placeholder={["From date", "To date"]}
            disabledDate={disabledDate}
            onChange={onRangeChange}
          />

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button mis-auto"
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={items.list}
          loading={tableLoading}
          className="rs-table table-text-nowrap match-height"
          scroll={{
            x: true,
          }}
          pagination={{
            current: params.page_number,
            pageSize: params.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
          summary={() => {
            return (
              items.list.length > 0 && (
                <Table.Summary.Row className="custom-bg-table">
                  {columns.map((col: any, index) => {
                    if (index === 0) {
                      return (
                        <Table.Summary.Cell
                          index={index}
                          key={col.key || index}
                        >
                          Total
                        </Table.Summary.Cell>
                      );
                    }
                    if (col.key === "amount") {
                      return (
                        <Table.Summary.Cell
                          index={index}
                          key={col.key || index}
                          align="left"
                        >
                          {numberFormat(totalIncome)}
                        </Table.Summary.Cell>
                      );
                    }
                    return (
                      <Table.Summary.Cell
                        index={index}
                        key={col.key || index}
                        align="center"
                      >
                        -
                      </Table.Summary.Cell>
                    );
                  })}
                </Table.Summary.Row>
              )
            );
          }}
        />
      </Layout>
    </>
  );
};

export default ListPayment;
